import CommonDialog from "../../common/CommonDialog/CommonDialog";
import { useTranslation } from "hhn-commons";
import { IAddressData } from "./AddressMapHelper";
import AddressMap from "./AddressMap";
import theme from "../../theme";
import { useMediaQuery } from "@mui/material";

interface IAddressMapDialog {
  closeMapDialog: () => void;
  onSelectAddress: (addressData: IAddressData) => void;
  initialAddressData: IAddressData;
}

const AddressMapDialog = ({
  closeMapDialog,
  onSelectAddress,
  initialAddressData,
}: IAddressMapDialog) => {
  const { t } = useTranslation();

  const tNs = (key: string) => t(key, { ns: "patientGroup" });

  return (
    <CommonDialog
      isDialogOpen={true}
      onDialogClose={closeMapDialog}
      title={tNs("addressField.addressLabel")}
      maxWidth={useMediaQuery(theme.breakpoints.up("xl")) ? "lg" : "md"}
    >
      <AddressMap
        onSelectAddress={onSelectAddress}
        initialAddressData={initialAddressData}
        closeMapDialog={closeMapDialog}
      />
    </CommonDialog>
  );
};

export default AddressMapDialog;
